import { defineMessages, type MessageDescriptor } from 'react-intl';

type SummarizeInChatMessages = {
	summarizeInChatButtonText: MessageDescriptor;
};

export const i18n: SummarizeInChatMessages = defineMessages({
	summarizeInChatButtonText: {
		id: 'summarize-in-chat-button-text',
		defaultMessage: 'Summarize',
		description: 'Text for the button that summarizes the page in chat',
	},
});
